import { useInfiniteQuery } from '@tanstack/react-query'
import { apiClient } from '~/shared/api/data-ingestion-api'
import { retryUnlessClientError } from '~/shared/lib/api-error'
import { AGENT_RUNS_PAGE_SIZE, DOCUMENT_AGENT_QUERY_KEYS } from '../config'
import type { AgentRunsFilters, AgentRunsListResponse } from '../model'

export function useAgentRuns(filters: AgentRunsFilters) {
  return useInfiniteQuery({
    queryKey: DOCUMENT_AGENT_QUERY_KEYS.runs(filters),
    queryFn: async ({ pageParam }) => {
      const response = await apiClient.client.get({
        url: '/document-agent/runs',
        query: {
          date_from: filters.dateFrom,
          date_to: filters.dateTo,
          run_label: filters.runLabel || undefined,
          limit: AGENT_RUNS_PAGE_SIZE,
          cursor: pageParam,
        },
        throwOnError: true,
      })
      return response.data as AgentRunsListResponse
    },
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage) => lastPage.next_cursor ?? undefined,
    retry: retryUnlessClientError,
  })
}
